

export class ReportingTicket {
  duration: number = 0;
  maxDuration: number = 0;
  tmpMaxDuration: number = 0;
  interval: NodeJS.Timeout | number | undefined;
  ticketId: string = '';
  isPlaying: boolean = false;
  $api: any
  constructor(api: any) {
    this.$api = api;
  }
  async trackingReport(
    ticketId: string,
    type: string = 'listened',
    duration: number,
    maxDuration: number,
    partial: boolean = true
  ) {
    if (this.ticketId) {
      const date = new Date().toISOString();
      try {

        let response = await (this.$api.endPoints as any).reportTracking(
          ticketId,
          type,
          duration,
          maxDuration,
          partial,
          date
        );
        return response;
      } catch (error) {
        this.resetReporting();
        this.ticketId = '';
      }
    }
  }

  // Handle Reporting and Interval Increment
  handleReporting(isEnded?: boolean) {
    if (isEnded) {
      this.resetReporting();
    } else {
      this.pauseReporting();
    }
    if (process.client) {
      this.interval = setInterval(() => {
        this.countReporting();
      }, 1000);
    }
  }

  // Reset Counters and Interval
  resetReporting() {
    this.duration = 0;
    this.maxDuration = 0;
    this.tmpMaxDuration = 0;
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = undefined;
    }
  }

  // Start Count and reporting
  countReporting() {
    if (!this.isPlaying) {
      return;
    }
    this.duration++;
    this.tmpMaxDuration++;
    if (this.tmpMaxDuration > this.maxDuration) {
      this.maxDuration = this.tmpMaxDuration;
    }
    // check for Mod the duration and send to server every 15
    if (this.duration % 15 === 0)
      this.trackingReport(
        this.ticketId,
        'listened',
        this.duration,
        this.maxDuration
      );
  }

  // End of track reset count and reporting
  endReporting() {
    //TODO Send report partial false
    if (this.ticketId) {
      this.trackingReport(
        this.ticketId,
        'listened',
        this.duration,
        this.maxDuration,
        false
      );
      this.resetReporting();
      this.ticketId = '';
    } else {
      console.warn('No TicketId Found');
    }
    //reset reporting interval
  }
  // Pause track
  pauseReporting() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = undefined;
    }
    // return;
  }
}